/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs */

const en_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production deployment`)
};

const ar_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشر في الإنتاج`)
};

const bn_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশন ডিপ্লয়মেন্ট`)
};

const de_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktionsbereitstellung`)
};

const es_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despliegue de producción`)
};

const fr_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement en production`)
};

const pt_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantação de produção`)
};

const zh_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产部署`)
};

const tr_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim dağıtımı`)
};

const ru_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производственное развертывание`)
};

const pl_svc_full_stack_web_apps_deploy_title6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie produkcyjne`)
};

/**
* | output |
* | --- |
* | "Production deployment" |
*
* @param {Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_deploy_title6 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Deploy_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_deploy_title6(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_deploy_title6(inputs)
	return en_svc_full_stack_web_apps_deploy_title6(inputs)
});
export { svc_full_stack_web_apps_deploy_title6 as "svc_full-stack-web-apps_DEPLOY_title" }